/**
 * Hulpfuncties rond inkooporders.
 */

/**
 * Inkooporders op ordernummer, nieuwste eerst.
 *
 * Een ordernummer ziet eruit als `IO-20241209-45`: een datumdeel en een
 * volgnummer. Er wordt eerst op het datumdeel gesorteerd en daarna op het
 * volgnummer, allebei aflopend — puur alfabetisch sorteren zet `-9` namelijk
 * ná `-45`.
 *
 * Deze sortering zat tot BMX-11 verstopt in `organizeOrdersWithChildren`, die
 * daarnaast child-orders onder hun parent hing. Die groepering is weg (order
 * splitsen bestaat niet meer), het sorteren niet: het bepaalt de vaste volgorde
 * van de inkooporderlijst, er staat bewust geen sorter op de kolom.
 *
 * Sorteert een kopie; de invoer blijft ongemoeid.
 */
export const sortPurchaseOrdersByNumberDesc = (orders) => {
  if (!orders) return [];

  const datePart = (orderNumber) => {
    if (!orderNumber) return "";
    const parts = orderNumber.split("-");
    return parts.length >= 2 ? parts[1] : "";
  };

  const sequencePart = (orderNumber) => {
    if (!orderNumber) return 0;
    const parts = orderNumber.split("-");
    return parseInt(parts[parts.length - 1], 10) || 0;
  };

  return [...orders].sort((a, b) => {
    const dateA = datePart(a.orderNumber);
    const dateB = datePart(b.orderNumber);
    if (dateA !== dateB) return dateB.localeCompare(dateA);
    return sequencePart(b.orderNumber) - sequencePart(a.orderNumber);
  });
};
